import fetch from 'isomorphic-fetch';
import Constants from '../definitions/constants';
import InterfaceTooling from '../tooling/interfaceTooling';
import JavascriptUtilsTooling from '../tooling/javascriptUtilsTooling';
import LocaleTooling from './localeTooling';
import { intl } from '../locales/localesConfig';
import toastr from 'toastr';

const popupIds = {
  formPopup: "formPopup",
  importFormPopup: "importFormPopup",
  deleteConfirmPopup: "deleteConfirmPopup",
  activeConfirmPopup: "activeConfirmPopup"
}

//tienen que ser llamados con bind this desde el container TODO los primeros metodos cambiarlos a este estilo
const EntityTableTooling = {
  getListQueryParams: (containerObject) => {
    let queryParams = {
      page: containerObject.props.list.page,
      per_page: containerObject.props.list.pageSize,
      order_fields: [containerObject.props.list.orderBy ? containerObject.props.list.orderBy 
        : (containerObject.state.tableDescriptor.columns[0].sortField ? 
           containerObject.state.tableDescriptor.columns[0].sortField : containerObject.state.tableDescriptor.columns[0].key)],
      order_directions: [containerObject.props.list.orderByDirection ? containerObject.props.list.orderByDirection
        : Constants.crudGenerator.orderTypes.ASC],
      fields_are: !containerObject.state.topControlsFormData.showDisabledEntities ? ["active"] : null,
      searches_are: !containerObject.state.topControlsFormData.showDisabledEntities ? [true] : null,
      fields_like: containerObject.state.topControlsFormData.searchText!="" ? 
        [containerObject.state.tableDescriptor.generalTextSearchFields] : null,
      searches_like: containerObject.state.topControlsFormData.searchText!="" ? 
        containerObject.state.tableDescriptor.generalTextSearchFields.map(item => {
          return containerObject.state.topControlsFormData.searchText;
        }) : null,
      timezone_offset: new Date().getTimezoneOffset()
    };
    if(containerObject.getListQueryParams) {
      return containerObject.getListQueryParams(queryParams)
    }
    return queryParams;
  },
  fetchList: async (containerObject) => {
    await containerObject.props.actions.getList(EntityTableTooling.getListQueryParams(containerObject));
    if(containerObject.fetchListCallback) {
      containerObject.fetchListCallback()
    }
  },
  fetchListNextPage: async (containerObject, event) => {
    var page = +event.currentTarget.dataset.targetpage;
    if(containerObject.props.list.status === 200 && containerObject.props.list.page<=containerObject.props.list.totalPages) {
      await containerObject.props.actions.getList(Object.assign(EntityTableTooling.getListQueryParams(containerObject), {
        page: page,
      }), true);
    }  
  },
  fetchListOrder: async (containerObject, event) => {
    var direction = Constants.crudGenerator.orderTypes.ASC;
    if(event.currentTarget.dataset.field == containerObject.props.list.orderBy) {
      direction = containerObject.props.list.orderByDirection == Constants.crudGenerator.orderTypes.ASC ? 
        Constants.crudGenerator.orderTypes.DESC : Constants.crudGenerator.orderTypes.ASC;
    }
    await containerObject.props.actions.getList(Object.assign(EntityTableTooling.getListQueryParams(containerObject), {
      page: 1,
      order_fields: [event.currentTarget.dataset.field],
      order_directions: [direction],
    }));
  },
  fetchListSearch: async (containerObject) => {
    await containerObject.props.actions.getList(Object.assign(EntityTableTooling.getListQueryParams(containerObject),{
      page: 1,
    }));
  },
  handleOnChangeTopControls: (containerObject, event) => {
    let topControlsFormData = { ...containerObject.state.topControlsFormData };
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    
    if(event.currentTarget.dataset.path == "selectedTags") {
      let path = "selectedTags"
      let index = event.currentTarget.dataset.index;
      let objectValue = event.currentTarget.dataset.value
      let isDelete = event.currentTarget.dataset.delete;
      let objectDefinition = [];

      objectDefinition = JavascriptUtilsTooling.deepCopy(containerObject.state.topControlsFormData[path]);
          
      
      if(isDelete) { 
        delete objectDefinition[index];
        objectDefinition = objectDefinition.filter(item => item);
      }      
      else if(objectDefinition.length >= Constants.interface.maxSelectedTagsFilter) {
        toastr.options = Constants.interface.tostrOptions;
        toastr.error(intl.formatMessage({id: "common.errors.maxSelectedTagsFilter"}, {maxTags: Constants.interface.maxSelectedTagsFilter}));
      }
      else {
        objectDefinition.push(objectValue);
      }
      containerObject.setState({ 
        topControlsFormData: {
          ...containerObject.state.topControlsFormData,
          [path]: objectDefinition
        }
      });
    }
    else{
      topControlsFormData[event.currentTarget.id] = value;
      containerObject.setState({
        topControlsFormData: topControlsFormData
      });
    }
    
    if(event.currentTarget.id == "periodIdSelected" && containerObject.props.periodId) {
      containerObject.props.actions.setPeriodId(value);
    }
    if(event.currentTarget.id != "showAuditColumn") {
      containerObject.state.searchTimeoutObject = InterfaceTooling.delayCallAction(
        EntityTableTooling.fetchListSearch.bind(null, containerObject), 
        containerObject.state.searchTimeoutObject
      );
    }    
  },
  handleOnChangeForm: (containerObject, event) => {
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    containerObject.props.actions.setSaveEntityDataByKey(event.currentTarget.dataset.path,value);
    containerObject.setState({ formHasChanges: true });
  },
  handleOnSaveForm: async (containerObject) => {
    let dataToSend =  JavascriptUtilsTooling.deepCopy(containerObject.props.save.data);
    if(containerObject.props.periodId) {
      dataToSend.period_id = containerObject.props.periodId;
    }
    await containerObject.props.actions.saveEntity(dataToSend);
  },
  handleShowFormPopup: (containerObject, event) => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.formPopup, containerObject.state, 
      containerObject.setState.bind(containerObject), containerObject.props.save.loading, () => {
        let entityObject = {};        
        if(event && event.currentTarget.dataset.entitydata) {
          entityObject[containerObject.state.entityApiKey] = JSON.parse(event.currentTarget.dataset.entitydata)
          containerObject.props.actions.resetSaveEntity(entityObject);
        }
        else {
          entityObject[containerObject.state.entityApiKey] = containerObject.state.initialNewEntity;
          containerObject.props.actions.resetSaveEntity(entityObject);
        }       
      }
    );
  },
  handleShowFormPopupWithConfirmOnExit: (containerObject, event) => {
    InterfaceTooling.handleShowFormPopupWithConfirmOnExit(
      event, popupIds.formPopup, containerObject.state, 
      containerObject.setState.bind(containerObject), containerObject.props.save.loading, () => {
        let entityObject = {};        
        if(event.currentTarget.dataset.entitydata) {
          entityObject[containerObject.state.entityApiKey] = JSON.parse(event.currentTarget.dataset.entitydata)
          containerObject.props.actions.resetSaveEntity(entityObject);
        }
        else {
          entityObject[containerObject.state.entityApiKey] = containerObject.state.initialNewEntity;
          containerObject.props.actions.resetSaveEntity(entityObject);
        }
        containerObject.setState({
          formHasChanges: false
        });       
      }
    );
  },
  handleDownloadImportSheet: async (containerObject) => {
    let dataToSend = {
      active: !document.getElementById('import_include_deactivated').checked
    };
    if(containerObject.props.periodId) {
      dataToSend.period_id = containerObject.props.periodId;
    }
    await containerObject.props.actions.downloadImportFile(dataToSend);
  },
  handleOnSaveImportForm: async (containerObject, event) => {
    let files = [];
    files = document.getElementById('import_file').files;
    files = Object.keys(files).map(key => files[key]);
    document.getElementById('import_file').value = '';
    if(containerObject.props.periodId) {
      await containerObject.props.actions.importEntities(files, {
        period_id: containerObject.props.periodId   
      }); 
    }
    else {
      await containerObject.props.actions.importEntities(files);
    }
  },
  handleShowImportFormPopup: (containerObject, event) => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.importFormPopup, containerObject.state, 
      containerObject.setState.bind(containerObject), containerObject.props.import.loading, () => {
        containerObject.props.actions.resetImport();      
      }    
    );
  },
  handleDeletePopup: async (containerObject, event) => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.deleteConfirmPopup, containerObject.state, 
      containerObject.setState.bind(containerObject), containerObject.props.delete.loading, () => {
        containerObject.props.actions.prepareDeleteEntity(event.currentTarget.dataset.id);
      }
    );
  },
  handleDeleteConfirm: async (containerObject) => {
    await containerObject.props.actions.deleteEntity({id: containerObject.props.delete.id});
  },
  handleActivePopup: async (containerObject, event) => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.activeConfirmPopup, containerObject.state, 
      containerObject.setState.bind(containerObject), containerObject.props.save.loading, () => {
        let entity = JSON.parse(event.currentTarget.dataset.entitydata);
        let entityObject = {};
        entity.active = !entity.active;
        entityObject[containerObject.state.entityApiKey] = entity;
        containerObject.props.actions.resetSaveEntity(entityObject);
      }
    );
  },
  handleActiveConfirm: async (containerObject) => {
    let dataToSend =  {...containerObject.props.save.data, just_active: true};
    if(containerObject.props.periodId) {
      dataToSend.period_id = containerObject.props.periodId;
    }
    await containerObject.props.actions.saveEntity(dataToSend);
  },
  getFormPopupState: (containerObject) => {
    return containerObject.state[popupIds.formPopup];
  },
  getDeletePopupState: (containerObject) => {
    return containerObject.state[popupIds.deleteConfirmPopup];
  },
  getActivePopupState: (containerObject) => {
    return containerObject.state[popupIds.activeConfirmPopup];
  },
  getImportPopupState: (containerObject) => {
    return containerObject.state[popupIds.importFormPopup];
  },
  feedbackMessages: (containerObject, prevProps, entityName, entityNamePlural, genderVocal, not_aceptable_delete_detail = "", not_acceptable_deactivate_detail = null, fetchTagsOnSuccess = false) => {
    //handle save feedback
    let saveStatus = containerObject.props.save.status;
    InterfaceTooling.apiCallResultFeedback(
      [prevProps.save.status],
      [saveStatus],
      LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage( 
        {id: "common.entity.saveEntitySuccess"},
        {entityNameSingular: entityName, genderVocal: genderVocal })),
      InterfaceTooling.popupHasToRender(containerObject.state[popupIds.activeConfirmPopup]) ? 
        (saveStatus==406 ? 
          LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({id: "common.entity.saveEntityCantDeactivateError"}, {entityNameSingular: entityName, detail: (not_acceptable_deactivate_detail ? not_acceptable_deactivate_detail : not_aceptable_delete_detail)})) :
        saveStatus==423 ?
          intl.formatMessage({ id: "common.errors.systemLockedError" }) :
          LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({id: "common.entity.saveEntityError"},{entityNameSingular: entityName.toLowerCase()}))
        )
        : null,
      [() => {
        if(InterfaceTooling.popupHasToRender(containerObject.state[popupIds.formPopup])) {
          InterfaceTooling.popupHide(popupIds.formPopup, containerObject.setState.bind(containerObject));
        }
        if(InterfaceTooling.popupHasToRender(containerObject.state[popupIds.activeConfirmPopup])) {
          InterfaceTooling.popupHide(popupIds.activeConfirmPopup, containerObject.setState.bind(containerObject));
        }
        EntityTableTooling.fetchList(containerObject);        
        containerObject.setState({ formHasChanges: false });
        if(fetchTagsOnSuccess) {
          containerObject.props.actions.getTagsList();
        }
      }]
    );

    //handle delete feedback
    let deleteStatus = containerObject.props.delete.status;
    InterfaceTooling.apiCallResultFeedback(
      [prevProps.delete.status],
      [deleteStatus],
      LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage(
        { id: "common.entity.deleteEntitySuccess" },
        {entityNameSingular: entityName, genderVocal: genderVocal })),
      deleteStatus==406 ? 
      LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "common.entity.deleteEntityCantDeleteError" }, {entityNameSingular: entityName, detail: not_aceptable_delete_detail})) :
      deleteStatus==423 ?
        intl.formatMessage({ id: "common.errors.systemLockedError" }) :
        LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "common.entity.deleteEntityError" }, {entityNameSingular: entityName.toLowerCase()})),
      [() => {
        if(InterfaceTooling.popupHasToRender(containerObject.state[popupIds.deleteConfirmPopup])) {
          InterfaceTooling.popupHide(popupIds.deleteConfirmPopup, containerObject.setState.bind(containerObject));
        }
        EntityTableTooling.fetchList(containerObject);       
      }]    
    );
    
    if(prevProps.downloadImport) {
      //handle download imoprt feedback
      InterfaceTooling.apiCallResultFeedback(
        [prevProps.downloadImport.status],
        [containerObject.props.downloadImport.status],
        intl.formatMessage({ id: "common.entity.downloadImportFileSuccess" }),
        intl.formatMessage({ id: "common.entity.downloadImportFileFailure" })
      );

      //handle imoprt feedback
      InterfaceTooling.apiCallResultFeedback(
        [prevProps.import.status],
        [containerObject.props.import.status],
        LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage(
          { id: "common.entity.uploadImportSuccess" },
          {entityNameSingular: entityNamePlural.toLowerCase()})),
        null,
        [() => {
          if(InterfaceTooling.popupHasToRender(containerObject.state[popupIds.importFormPopup])) {
            InterfaceTooling.popupHide(popupIds.importFormPopup, containerObject.setState.bind(containerObject));
          }    
        }]  
      );    
    }
  },
};

export default EntityTableTooling;


// WEBPACK FOOTER //
// ./source/tooling/entityTableTooling.js